//  Common base styles
const badgeBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "4px 10px",
  borderRadius: "9999px", // pill shape
  fontWeight: 500,
  fontSize: "0.875rem",
  color: "#FFFFFF",
};

const scheduleBaseStyle = {
  padding: "4px 12px",
  borderRadius: "20px",
  fontWeight: 600,
  fontSize: "0.9rem",
  width: "100px",
  textAlign: "center",
};

//  OPTIONS
export const statusOptions = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const currentStatusOptions = [
  { label: "All", value: "" },
  { label: "Available", value: 1 },
  { label: "Not Available	", value: 0 },

];

export const projectTypeOptions = [
  { label: "Contract", value: 0 },
  { label: "One Time", value: 1 },
];

export const scheduleProcessOptions = [
  { label: "All", value: "" },
  { label: "New", value: 0 },
  { label: "In Progress", value: 1 },
  { label: "Completed", value: 2 },
  { label: "On hold", value: 3 },
];

export const scheduleStatusSearchOptions = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
  { label: "Cancelled", value: 5 },
];

export const moveToClientStatus = [
  { label: "Sent to client", value: 1 },
  { label: "Ready for submission", value: 0 },
];

export const moveToClientInvoiceStatus = [
  { label: "Sent to client", value: 1 },
  { label: "New", value: 0 },
];

export const moveToFinanceStatus = [
  { label: "Sent to finance", value: 1 },
  { label: "New", value: 0 },
];

export const paymentStatusOptions = [
  { label: "Not Paid", value: 0 },
  { label: "Paid", value: 1 },
];

export const invoiceStatusOptions = [
  { label: "New", value: 0 },
  { label: "Invoice Created", value: 1 },
];

export const leaveStatusOptions = [
  { label: "All", value: "" },
  { label: "In progress", value: 0 },
  { label: "Approved", value: 1 },
  { label: "Rejected", value: 2 },
];

// AUDIT LOG SOURCE DROPDOWN
export const sourceOptions = [
  { label: "Android", value: "android" },
  { label: "iOS", value: "ios" },
  { label: "Web", value: "web" },
];


// DROP DOWN VALUES  END  

//  REPORT COLORS
export const reportStageColors = {
  draft: "#1976d2",
  review: "#f9a825",
  analysis: "#00acc1",
  submit: "#2e7d32",
  "n/a": "#9e9e9e",
};


// Employee Report job type ddl
export const jobTypeOptions = [
  { label: 'All', value: '' },
  { label: 'Worksite', value: 'Worksite' },
  { label: 'Clerical', value: 'Clerical' },

];


// leave progress badge
export const getLeaveProgressColors = (status) => {
  switch (status) {
    case 0:
      return {
        ...badgeBaseStyle,
        backgroundColor: "#FFA91B", // orange bg
      };
    case 1:
      return {
        ...badgeBaseStyle,
        backgroundColor: "#25C16F", // green bg
      };
    case 2:
      return {
        ...badgeBaseStyle,
        backgroundColor: "#F5544B", // red bg
      };
    default:
      return badgeBaseStyle;
  }
};

// schedule action colors
export const getActionColors = (status) => {
  switch (status) {
    case 1:
      return { color: "#F57C00", backgroundColor: "#FFE0B2" };
    case 2:
      return { color: "#2E7D32", backgroundColor: "#C8E6C9" };
    case 3:
      return { color: "#FF234E", backgroundColor: "#FFCDD2" };
    case 4:
      return { color: "#F57C00", backgroundColor: "#FFE0B2" };
    default:
      return { color: "#007BFF", backgroundColor: "#BBDEFB" };
  }
};

// FSE Calendar Schedule Status Styles
export const getFseCalendarScheduleStyle = (status) => {
  switch (status) {
    case 1:
      return { color: "#F57C00", backgroundColor: "#FFE0B2" };
    case 2:
      return { color: "#2E7D32", backgroundColor: "#C8E6C9" };
    case 3:
      return { color: "#FF234E", backgroundColor: "#FFCDD2" };
    case 4:
      return { color: "#F57C00", backgroundColor: "#FFE0B2" };
    default:
      return { color: "#007BFF", backgroundColor: "#BBDEFB" };
  }
};

// schedule progress badge
export const getScheduleProgressStyle = (status) => {
  switch (status) {
    case 1:
      return {
        ...scheduleBaseStyle,
        color: "#F57C00",
        backgroundColor: "#FFE0B2",
        border: "1px solid #FFCC80",
      };
    case 2:
      return {
        ...scheduleBaseStyle,
        color: "#2E7D32",
        backgroundColor: "#C8E6C9",
        border: "1px solid #A5D6A7",
      };
    case 3:
      return {
        ...scheduleBaseStyle,
        color: "#D32F2F",
        backgroundColor: "#FDECEA",
        border: "1px solid #F5C6CB",
      };
    case 4:
      return {
        ...scheduleBaseStyle,
        color: "#F57C00",
        backgroundColor: "#FFE0B2",
        border: "1px solid #FFCC80",
      };
    default:
      return {
        ...scheduleBaseStyle,
        color: "#007BFF",
        backgroundColor: "#BBDEFB",
        border: "1px solid #90CAF9",
      };
  }
};

// generic status badge
export const getStatusColors = (status) => {
  switch (status) {
    case 1: // Active
      return { ...badgeBaseStyle, backgroundColor: "#25C16F" };
    case 2: // Inactive
      return { ...badgeBaseStyle, backgroundColor: "#FFA91B" };
    case 3: // Cancelled
      return { ...badgeBaseStyle, backgroundColor: "#F5544B" };
    default: // Blue fallback
      return { ...badgeBaseStyle, backgroundColor: "#5B6BF3" };
  }
};

// highlight row background
export const getRowHighlightStyle = (row) => {
  if (row.is_Schedule_Cancled === 1) { //CANCELLED
    return {
      backgroundColor: "#ffcccc !important",
      color: "red !important",
    };
  }
  if (row.is_Invoice_Paid === true) { //INVOICE PAID
    return {
      backgroundColor: "#E8F5E9 !important", // light green
      color: "green",
    };
  }
  if (row.scheduleIsAccept) { //REPORT ACCEPTED BY DOC FSE (REPORT BIN)
    return {
      // backgroundColor: "#BBDEFB !important", // light green
      color: "#006CB8",
    };
  }
  return { backgroundColor: "transparent" };
};
